import { style } from '@vanilla-extract/css';
import { calc } from '@vanilla-extract/css-utils';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';

export const popoverPanel = style(
  {
    border: 'none',
    maxHeight: 'inherit',
    maxWidth: 'inherit',
  },
  'segment-popover-panel',
);

export const popoverConditions = style(
  {
    maxHeight: '230px',
    overflow: 'auto',
    paddingTop: themeVars.space['200'],
  },
  'segment-popover-conditions',
);

/** The card's width floor, as `SEGMENT_POPOVER_CONTENT_MIN_WIDTH` sets it: 62 steps of the 100 space. */
export const popoverMinWidth = style(
  {
    minWidth: calc.multiply(themeVars.space['100'], 62),
  },
  'segment-popover-min-width',
);
